document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href="/pages/about-us"]').forEach((link) => {
    link.setAttribute('href', '/pages/about');
  });

  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('.mobile-nav');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      menu.hidden = open;
    });
  }

  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const buyNowButton = event.target.closest('.shopify-payment-button__button');
      if (!buyNowButton || form.dataset.checkoutLoading === 'true') return;
      form.dataset.checkoutLoading = 'true';
      buyNowButton.classList.add('is-processing');
      buyNowButton.setAttribute('aria-busy', 'true');
      const status = form.querySelector('[data-product-form-status]');
      if (status) status.textContent = 'Opening secure checkout…';
      window.setTimeout(() => {
        form.dataset.checkoutLoading = 'false';
        buyNowButton.classList.remove('is-processing');
        buyNowButton.removeAttribute('aria-busy');
        if (status?.textContent === 'Opening secure checkout…') status.textContent = '';
      }, 8000);
    });

    form.addEventListener('submit', async (event) => {
      const addButton = form.querySelector('[data-add-to-cart]');
      if (event.submitter && event.submitter !== addButton) return;
      event.preventDefault();
      const submitButton = addButton;
      const status = form.querySelector('[data-product-form-status]');
      if (submitButton) submitButton.disabled = true;
      if (status) status.textContent = 'Adding to cart…';
      try {
        const response = await fetch(form.action, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await fetch('/cart.js').then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
        if (submitButton) submitButton.textContent = 'Added to cart';
        if (status) status.textContent = 'Added. Opening your cart…';
        window.setTimeout(() => { window.location.href = '/cart'; }, 450);
      } catch (error) {
        if (status) status.textContent = 'Could not add this item. Please try again.';
        if (submitButton) { submitButton.disabled = false; submitButton.textContent = 'Add to Cart'; }
      } finally {
        if (submitButton && !status?.textContent.includes('Added')) submitButton.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-home-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-home-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-slide-dot]'));
    if (slides.length < 2) return;
    let active = 0;
    const show = (next) => {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => { slide.classList.toggle('is-active', index === active); slide.classList.toggle('active', index === active); });
      dots.forEach((dot, index) => dot.toggleAttribute('aria-current', index === active));
    };
    slider.querySelector('[data-slide-prev]').addEventListener('click', () => show(active - 1));
    slider.querySelector('[data-slide-next]').addEventListener('click', () => show(active + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    window.setInterval(() => show(active + 1), 5000);
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const mainImage = section.querySelector('.main-image img');
    const quantityInput = section.querySelector('input[name="quantity"]');
    const thumbnails = Array.from(section.querySelectorAll('[data-product-thumbnail]'));
    const shippingProgress = section.querySelector('[data-shipping-progress]');
    const updateShippingProgress = () => {
      if (!shippingProgress) return;
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const cartSubtotal = Number(shippingProgress.dataset.cartSubtotal || 0);
      const productPrice = Number(shippingProgress.dataset.productPrice || 0);
      const shippingThreshold = Number(shippingProgress.dataset.shippingThreshold || 50000);
      const projectedSubtotal = cartSubtotal + (productPrice * quantity);
      const formatMoney = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'INR',
        maximumFractionDigits: 0
      }).format(amount / 100);
      if (projectedSubtotal >= shippingThreshold) {
        shippingProgress.textContent = '✓ Free delivery unlocked for this order.';
      } else {
        shippingProgress.textContent = `Add ${formatMoney(shippingThreshold - projectedSubtotal)} more to unlock free delivery. Otherwise, ₹70 shipping applies.`;
      }
    };
    const showProductImage = (thumbnail) => {
      if (!mainImage) return;
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.alt = thumbnail.dataset.imageAlt || mainImage.alt;
      thumbnails.forEach((item) => item.classList.toggle('active', item === thumbnail));
    };
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => showProductImage(thumbnail)));
    const moveGallery = (direction) => {
      const activeIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('active')));
      showProductImage(thumbnails[(activeIndex + direction + thumbnails.length) % thumbnails.length]);
    };
    section.querySelector('[data-gallery-prev]')?.addEventListener('click', () => moveGallery(-1));
    section.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveGallery(1));
    section.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.quantityChange));
      updateShippingProgress();
    }));
    quantityInput?.addEventListener('input', updateShippingProgress);
    const variantSelect = section.querySelector('[data-product-variant]');
    const variantsData = document.querySelector('[data-product-variants]');
    const price = section.querySelector('[data-product-price]');
    const addButton = section.querySelector('[data-add-to-cart]');
    if (variantSelect && variantsData && price) {
      const variants = JSON.parse(variantsData.textContent || '[]');
      variantSelect.addEventListener('change', () => {
        const selected = variants.find((variant) => String(variant.id) === variantSelect.value);
        if (!selected) return;
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: Shopify.currency.active }).format(selected.price / 100);
        if (shippingProgress) shippingProgress.dataset.productPrice = selected.price;
        updateShippingProgress();
        if (addButton) { addButton.disabled = !selected.available; addButton.textContent = selected.available ? '🛒 Add to Cart' : 'Sold out'; }
      });
    }
  });

  document.querySelectorAll('[data-product-tabs]').forEach((tabs) => tabs.querySelectorAll('[data-product-tab]').forEach((button) => button.addEventListener('click', () => {
    const name = button.dataset.productTab;
    tabs.querySelectorAll('[data-product-tab]').forEach((item) => item.classList.toggle('active', item === button));
    tabs.querySelectorAll('[data-product-panel]').forEach((panel) => panel.classList.toggle('active', panel.dataset.productPanel === name));
  })));

  document.querySelectorAll('.product-media-showcase__player').forEach((video) => {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }), { threshold: 0.45 });
    observer.observe(video);
  });

  document.querySelectorAll('[data-coupon-popup]').forEach((popup) => {
    const dialog = popup.querySelector('.coupon-popup__dialog');
    const onKeydown = (event) => { if (event.key === 'Escape') close(); };
    const close = () => {
      popup.hidden = true;
      document.removeEventListener('keydown', onKeydown);
    };
    popup.hidden = false;
    dialog?.focus();
    document.addEventListener('keydown', onKeydown);
    popup.querySelectorAll('[data-coupon-close]').forEach((button) => button.addEventListener('click', close));
    popup.querySelector('[data-coupon-copy]')?.addEventListener('click', async () => {
      const code = popup.querySelector('[data-coupon-code]')?.textContent.trim();
      const status = popup.querySelector('[data-coupon-status]');
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        if (status) status.textContent = 'Code copied — use it at checkout.';
      } catch (error) {
        if (status) status.textContent = `Use code ${code} at checkout.`;
      }
    });
  });

  document.querySelectorAll('[data-predictive-search]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const results = form.parentElement.querySelector('[data-predictive-results]');
    let timer;
    let requestId = 0;
    const closeResults = () => {
      results.hidden = true;
      results.replaceChildren();
      input.setAttribute('aria-expanded', 'false');
    };
    const addResult = (group, item, type) => {
      const link = document.createElement('a');
      link.className = 'search-predictive-item';
      link.href = item.url;
      const title = document.createElement('span');
      title.textContent = item.title;
      const label = document.createElement('span');
      label.className = 'search-predictive-item__type';
      label.textContent = type;
      link.append(title, label);
      group.append(link);
    };
    const showResults = (data, query) => {
      const resourceResults = data.resources?.results || {};
      const groups = [['Products', resourceResults.products], ['Articles', resourceResults.articles], ['Pages', resourceResults.pages], ['Collections', resourceResults.collections]];
      const fragment = document.createDocumentFragment();
      let count = 0;
      groups.forEach(([label, items]) => {
        if (!items?.length) return;
        const group = document.createElement('div');
        group.className = 'search-predictive-group';
        const heading = document.createElement('span');
        heading.className = 'search-predictive-group__title';
        heading.textContent = label;
        group.append(heading);
        items.forEach((item) => addResult(group, item, label.slice(0, -1)));
        count += items.length;
        fragment.append(group);
      });
      if (!count) {
        const empty = document.createElement('p');
        empty.className = 'search-predictive-empty';
        empty.textContent = `No quick matches for “${query}”. Press Search to see all results.`;
        fragment.append(empty);
      } else {
        const allResults = document.createElement('a');
        allResults.className = 'search-predictive-all';
        allResults.href = `${form.action}?q=${encodeURIComponent(query)}`;
        allResults.textContent = `View all results for “${query}” →`;
        fragment.append(allResults);
      }
      results.replaceChildren(fragment);
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const getSuggestions = async () => {
      const query = input.value.trim();
      if (query.length < 2) return closeResults();
      const thisRequest = ++requestId;
      const endpoint = new URL(form.action);
      endpoint.pathname = `${endpoint.pathname.replace(/\/$/, '')}/suggest.json`;
      endpoint.search = new URLSearchParams({ q: query, 'resources[type]': 'product,article,page,collection', 'resources[limit]': '8', 'resources[options][unavailable_products]': 'hide' }).toString();
      try {
        const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Suggestion request failed');
        const data = await response.json();
        if (thisRequest === requestId) showResults(data, query);
      } catch (error) {
        if (thisRequest === requestId) closeResults();
      }
    };
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(getSuggestions, 220);
    });
    form.parentElement.addEventListener('focusout', () => window.setTimeout(() => {
      if (!form.parentElement.contains(document.activeElement)) closeResults();
    }, 120));
    input.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeResults(); });
  });

  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    const status = form.querySelector('[data-cart-status]');
    const checkoutButton = form.querySelector('[name="checkout"]');
    let saving = Promise.resolve();
    const pendingTimers = new Map();
    const money = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'INR'
    }).format(amount / 100);
    const setStatus = (message) => { if (status) status.textContent = message; };
    const refreshCart = (cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      form.querySelectorAll('[data-cart-total]').forEach((node) => { node.textContent = money(cart.total_price); });
      cart.items.forEach((item) => {
        const cartItem = Array.from(form.querySelectorAll('[data-cart-item]')).find((node) => node.dataset.cartItemKey === item.key);
        const total = cartItem?.querySelector('.cart-item__total');
        if (total) total.textContent = money(item.final_line_price);
      });
    };
    const saveQuantity = async (input) => {
      const cartItem = input.closest('[data-cart-item]');
      const key = cartItem?.dataset.cartItemKey;
      const quantity = Math.max(0, Number(input.value || 0));
      if (!key) return;
      input.value = quantity;
      setStatus('Saving your cart…');
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!response.ok) throw new Error('Cart update failed');
        const cart = await response.json();
        if (quantity === 0) {
          cartItem.remove();
          if (cart.item_count === 0) window.location.reload();
        }
        refreshCart(cart);
        setStatus('Cart updated.');
      } catch (error) {
        setStatus('Your cart could not be updated. Please try again.');
      }
    };
    form.querySelectorAll('[data-cart-quantity]').forEach((control) => {
      const input = control.querySelector('[data-cart-quantity-input]');
      let timer;
      const queueSave = (immediate = false) => {
        window.clearTimeout(timer);
        const run = () => {
          pendingTimers.delete(input);
          saving = saving.then(() => saveQuantity(input));
        };
        if (immediate) run(); else {
          timer = window.setTimeout(run, 350);
          pendingTimers.set(input, timer);
        }
      };
      control.querySelectorAll('[data-cart-quantity-change]').forEach((button) => button.addEventListener('click', () => {
        input.value = Math.max(0, Number(input.value || 0) + Number(button.dataset.cartQuantityChange));
        queueSave(true);
      }));
      input.addEventListener('input', () => queueSave());
      input.addEventListener('change', () => queueSave(true));
    });
    form.addEventListener('submit', async (event) => {
      if (event.submitter?.name !== 'checkout') return;
      event.preventDefault();
      if (checkoutButton) checkoutButton.disabled = true;
      setStatus('Preparing secure checkout…');
      pendingTimers.forEach((timer, input) => {
        window.clearTimeout(timer);
        pendingTimers.delete(input);
        saving = saving.then(() => saveQuantity(input));
      });
      await saving;
      window.location.assign(form.dataset.checkoutUrl || '/checkout');
    });
  });
});
